<template>
  <div class="c-form-textfield">
		<validation-message
			:valid="valid"
			:invalid="invalid"
			:validationMessage="validationMessage"
		>
			<label class="c-form-textfield__label" :for="id">
				<input 
					class="c-form-textfield__input" 
					:type="type" 
					:name="name" 
					:placeholder="label" 
					:required=required 
					:disabled="disabled" 	
          v-model="value"
          :readonly="readonly"
					@input="updateValue"
					@change="changeValue"
          @keydown.enter.prevent="submitForm"
				/>
				<span class="c-form-textfield__label-text">
					{{label}}
					<span v-if="required" class="c-form-textfield__required"> *</span>
				</span>
			</label>
		</validation-message>
    <div v-if="tooltip" class="c-tooltip">
			<ToolTip :title="tooltipTitle" :isActive="isActiveTooltip" @toggleTooltip="(value) => $emit('toggleTooltip', value)">
        <span v-html="tooltipMessage"></span>
        <img v-if="tooltipImageUrl" class="test" width="84" height="117" :src="tooltipImageUrl" />
      </ToolTip>
    </div>
	</div>
</template>

<script>
import ValidationMessage from '../../../../base/validation-message/ValidationMessage.vue';
import ToolTip from '../../_contact-us-rap/_vue/ToolTip.vue';
export default {
  components: { ValidationMessage, ToolTip },
  inheritAttrs: false,
  props: {
    id: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
    },
		disabled: {
      required: false,
      type: Boolean,
    },
		tooltip: {
      required: false,
      type: Boolean,
    },
    tooltipTitle: {
      required: false,
      type: String,
    },
		tooltipMessage:{
			required: false,
      type: String,
		},
    tooltipImageUrl: {
      required: false,
      default: '',
      type: String,
    },
    isActiveTooltip: {
      type: Boolean,
    },
    type: {
      default: 'text',
      required: false,
      type: String,
    },
    value: {
      type: [String, Number],
    },
		valid: {
      type: Boolean,
      default: null
    },
    invalid: {
      type: Boolean,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validationMessage: {
      required: false,
      type: String,
    },
  },
  computed: {
    errorId() {
      return `${this.id}ErrorMsg`;
    },
    requiredCssClass() {
      return this.required ? 'c-form-textfield__label--required' : '';
    },
  },
  methods: {
    submitForm() {
      this.$emit('submit'); 
    },
    updateValue(event) {
			this.inputValue = event.target.value;
			this.$emit('input', this.inputValue); 
		},
		changeValue(event){
			this.inputValue = event.target.value;
			this.$emit('change', this.inputValue); 
		}
  },
}
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/forms/input/TextField.vue